import { createElement } from 'react';
import Col from '../col';
const Layout = (props) => {
    const { col, children, ...others } = props;
    const newChildren = [];
    const colSpan = `${24 / col}`;
    while (newChildren.length < col) {
        newChildren.push(createElement(Col, { colSpan: colSpan }));
    }
    return (createElement("div", Object.assign({ className: "ExampleComponent" }, others), children));
};
export default Layout;
